module.exports = __webpack_public_path__ + "img/temporomandibular.e3fe6e6e.png";